// services/stockImageService.ts  

import api from "./api";  

export interface UploadImageResult {
  id: number;
  stockId: number;
  url: string;
  sizeMB: number;
  isMain: boolean; 
}
  
export const uploadImageToServer = async (
  file: File, 
  stockId: number, 
  isMain: boolean = false
): Promise<UploadImageResult> => { // Artık null dönmüyor, hata fırlatıyor
  const formData = new FormData();
  formData.append('file', file);
  formData.append('stockId', stockId.toString());
  formData.append('isMain', isMain ? 'true' : 'false');

  // Not: Axios, FormData gönderirken Content-Type'ı otomatik 'multipart/form-data' yapar.
  const response = await api.post<UploadImageResult>('/stock-images/upload', formData); 
  return response.data;
};
export const deleteImageFromServer = async (imageId: number): Promise<boolean> => {
  try { 
    // Backend rotamız: DELETE /stock-images/delete?imageId=123
    const response = await api.delete(`/stock-images/delete?imageId=${imageId}`);
    
    // Axios ile 2xx yanıt alınırsa başarılı kabul edilir
    if (response.status === 200) {
      return true;
    }
    return false;

  } catch (error) {
    console.error("Görsel silme hatası:", error);
    return false;
  }
};

// --- STOCK COMPONENT IMAGE UPLOAD ---
export const uploadComponentImageToServer = async (
  file: File,
  componentId: number
): Promise<any> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('componentId', componentId.toString());

  const response = await api.post('/stock-images/upload-component', formData);
  return response.data;
};